<template>
    <div>

        <input type="text" title="Search" placeholder="Search" v-model="term" @input.prevent="$emit('search', term)">

    </div>
</template>

<script>
    export default {
        data() {
            return {
                term: '',
            }
        },
    }
</script>